import React from 'react';
import { Theme, withStyles } from '@material-ui/core';
import truncate from 'lodash/truncate';
import { pickupOrProNumbersString } from '../../../../utils';
import { DRIVER_MESSAGE_CONTENT } from '../../../content';
import { DRIVER_MESSAGE_LIMITS } from '../../../constants';
import type { DriverMessageItem } from '../../../types';

type RouteMaxTheme = Theme & {
  textFontSize?: number;
  TextColor?: string;
  notificationLinkColor?: string;
};

type MessageContentProps = {
  classes: Record<string, string>;
  item: DriverMessageItem;
};

const MessageContent = ({ classes, item }: MessageContentProps) => {
  const shipmentNumbers = item.metadata?.pickupNumbers || item.metadata?.proNumbers;
  const hasStopOrShipment = Boolean(item.metadata?.stopName) || Boolean(shipmentNumbers?.length);
  const truncatedMessage = truncate(item.message, {
    length: DRIVER_MESSAGE_LIMITS.messageTruncateLength,
    separator: DRIVER_MESSAGE_LIMITS.truncateSeparator,
  });

  if (!hasStopOrShipment && !truncatedMessage) {
    return null;
  }

  return (
    <div className={classes.messageSection}>
      {item.metadata?.stopName ? (
        <span className={classes.link}>
          {DRIVER_MESSAGE_CONTENT.stopNamePrefix}
          {item.metadata.stopName}
        </span>
      ) : null}
      {shipmentNumbers?.length ? (
        <span className={classes.link}>{pickupOrProNumbersString(shipmentNumbers.slice())}</span>
      ) : null}
      {truncatedMessage ? (
        <span className={classes.messageText}>
          {hasStopOrShipment ? ' ' : null}
          {truncatedMessage}
        </span>
      ) : null}
    </div>
  );
};

const styles = (theme: Theme) => {
  const routeMaxTheme = theme as RouteMaxTheme;

  return {
    messageSection: {
      display: 'block',
      width: '100%',
      fontSize: routeMaxTheme.textFontSize,
      color: routeMaxTheme.TextColor,
      lineHeight: '16px',
      wordBreak: 'break-word',
    },
    link: {
      color: routeMaxTheme.notificationLinkColor,
      fontWeight: 700,
    },
    messageText: {
      color: routeMaxTheme.TextColor,
    },
  };
};

export default withStyles(styles as Parameters<typeof withStyles>[0])(MessageContent);
